
import { useEffect, useState } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import { useIntl } from "react-intl";

import CustomTable from 'components/table';
import { masterPaginationServices, tableInitialState, } from 'utils/constants';
import { getTableParams } from 'utils/global';
import { RootReducerState } from 'utils/types';
import { getMasterPaginationData } from 'redux/actions';
import PageLayout from 'layouts/PageLayout';
import { userSurveyColumns } from 'utils/constants/tableColumn/column';
import { ActionMenu, ButtonGroup, CustomButton } from 'components';
import View from './View';
import { RemoveRedEye } from '@mui/icons-material';

const Index: React.FC = () => {
    const { formatMessage } = useIntl();
    const dispatch = useDispatch();
    const [tableState, setTableState] = useState(tableInitialState);
    const [drawer, setDrawer] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const { inquiresData, loading } = useSelector(
        ({ masterPaginationReducer }: RootReducerState) => ({
            inquiresData: masterPaginationReducer[masterPaginationServices.userSurvey].data,
            loading: masterPaginationReducer[masterPaginationServices.userSurvey].loading,
        }),
        shallowEqual
    );

    const { items, count } = inquiresData;

    useEffect(() => {
        onApiCall();
    }, [tableState]);

    function onApiCall() {
        const params = getTableParams(tableState);
        dispatch(getMasterPaginationData(masterPaginationServices.userSurvey, params));
    }

    function handleRowClick(rowData: any) {
        setSelectedRow(rowData);
        setDrawer(true);
    }

    const columnAction = [
        {
            label: formatMessage({ id: "action" }),
            name: "",
            options: {
                customBodyRender: (_: any, tableMeta: any) => {
                    const rowData = items[tableMeta.rowIndex];
                    return (
                        <ButtonGroup>
                            <CustomButton
                                color='warning'
                                size='small'
                                label="View"
                                variant='outlined'
                                onClick={() => handleRowClick(rowData)}
                                startIcon={<RemoveRedEye />}
                            />
                        </ButtonGroup>
                    )
                }
            }
        }]

    return (
        <PageLayout title={formatMessage({ id: "user-survey" })} hideToolbar>
            <CustomTable
                columns={[...userSurveyColumns(formatMessage), ...columnAction]}
                tableData={items}
                tableState={tableState}
                itemsCount={count}
                setTableState={setTableState}
                loading={loading}
            />
              {drawer && (
                <View
                    open={drawer}
                    closeModal={() => setDrawer(false)}
                    selectedData={selectedRow}
                    headerText={'User Surveyed Data'}
                />
            )}
        </PageLayout>
    )
}

export default Index;
